import { Outlet, useMatches } from 'react-router-dom'
import styled from 'styled-components'
import { BACK_UI_LAYER_ID } from '@/app/layoutLayerIds'
import { VRMViewerProvider } from '@/app/providers/VRMViewerProvider'
import { type GlobalBodyPreset, GlobalStyle } from '@/shared/styles/globals'

type RouteHandle = {
  globalBodyPreset?: GlobalBodyPreset
  showPersistentVrmViewer?: boolean
}

const resolveGlobalBodyPreset = (matches: ReturnType<typeof useMatches>): GlobalBodyPreset => {
  const match = [...matches].reverse().find((item) => (item.handle as RouteHandle | undefined)?.globalBodyPreset)
  return (match?.handle as RouteHandle | undefined)?.globalBodyPreset ?? 'default'
}

const shouldShowPersistentVrmViewer = (matches: ReturnType<typeof useMatches>): boolean =>
  matches.some((item) => (item.handle as RouteHandle | undefined)?.showPersistentVrmViewer === true)

const BackUiLayer = styled.div.attrs({
  id: BACK_UI_LAYER_ID,
})`
  position: fixed;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  height: 100%;
`

const ContentLayer = styled.div`
  position: relative;
  z-index: 4;

  display: flex;
  flex-direction: column;
  height: 100%;
`

const MobileViewArea = styled.div`
  position: fixed;
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 430px;
  height: 100vh;
  background-color: #ffffff0f;
  backdrop-filter: blur(4px);
`

export const RootLayout = () => {
  const matches = useMatches()
  const globalBodyPreset = resolveGlobalBodyPreset(matches)
  const showPersistentVrmViewer = shouldShowPersistentVrmViewer(matches)

  return (
    <VRMViewerProvider enabled={showPersistentVrmViewer}>
      <MobileViewArea />
      <GlobalStyle $bodyPreset={globalBodyPreset} />
      <BackUiLayer />
      <ContentLayer>
        <Outlet />
      </ContentLayer>
    </VRMViewerProvider>
  )
}
